/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { Box, Grid, IconButton, Tooltip } from '@mui/material';
import PhotoCameraOutlinedIcon from '@mui/icons-material/PhotoCameraOutlined';
import moment from 'moment';
import * as selectorsJornada from '../../../store/jornada/reducer';
import * as actionsJornada from '../../../store/jornada/actions';
import * as Role from '../../../constants/role';
import { JORNADA_ITEM_TIPOS } from '../../../constants/jornadaItemTipo';
import {
  DialogDefaultV2,
  ImageViewerV2,
  InputV2,
  InputFormatV2,
  UsuarioSelectV2,
  OptionSelectV2,
  DatePickerV2,
  TabFormV2,
  WidgetV2,
} from '../../../components/v2';
import InspecoesDia from './InspecoesDia';
import { convertTimeToMinutes, formatToTime } from 'utils';
import {
  computeJornadaTotalMinutes,
  formatEnderecoItem,
  geoPointsFromItens,
  itensByTipo,
  timesFromItens,
} from '../../../helpers/jornadaHelpers';
import JornadaGeoLine from '../../../helpers/JornadaGeoLine';
import JornadaPontosMap from '../../../helpers/JornadaPontosMap';

const emptyValues = () => ({
  data: moment().valueOf(),
  tipoControle: 'CONTROLE_JORNADA',
  itens: [],
});

const Formulario = ({
  open,
  id,
  onClose,
  loadJornada,
  jornada,
}) => {
  const [values, setValues] = useState(emptyValues);
  const [openMapa, setOpenMapa] = useState(false);
  const [tab, setTab] = useState(0);
  const [viewerOpen, setViewerOpen] = useState(false);
  const [viewerIndex, setViewerIndex] = useState(0);

  const byTipo = useMemo(() => itensByTipo(values.itens), [values.itens]);
  const pontos = useMemo(() => geoPointsFromItens(values.itens), [values.itens]);
  const fotosJornada = useMemo(() => (
    JORNADA_ITEM_TIPOS.flatMap(({ tipo, label, timeField }) => {
      const item = byTipo[tipo];
      const url = item?.foto?.url;
      if (!url) return [];
      return [{
        tipo,
        src: url,
        nome: [label, values[timeField]].filter(Boolean).join(' · '),
        alt: formatEnderecoItem(item?.enderecoJson) || undefined,
      }];
    })
  ), [byTipo, values]);

  useEffect(() => {
    if (id) loadJornada(id);
  }, [id, loadJornada]);

  useEffect(() => {
    if (id && jornada && id === jornada.id) {
      const times = timesFromItens(jornada.itens);
      const totalMinutes = computeJornadaTotalMinutes(times, convertTimeToMinutes)
        || jornada.jornadaTotalMinutes;
      setValues({
        ...jornada,
        ...times,
        data: moment(parseInt(jornada.data, 10)).valueOf(),
        itens: jornada.itens || [],
        jornadaTotal: totalMinutes
          ? formatToTime(totalMinutes)
          : (jornada.jornadaTotal || null),
      });
    } else if (!id) {
      setValues(emptyValues());
    }
  }, [jornada, id]);

  const onCloseLocal = () => {
    setValues(emptyValues());
    setOpenMapa(false);
    setViewerOpen(false);
    setTab(0);
    onClose(false);
  };

  const openFoto = (tipo) => {
    const index = fotosJornada.findIndex((foto) => foto.tipo === tipo);
    if (index < 0) return;
    setViewerIndex(index);
    setViewerOpen(true);
  };

  const informacoesGerais = (
    <Grid container spacing={1} sx={{ mt: 0 }}>
      <Grid size={{ xs: 12, sm: 3 }}>
        <DatePickerV2
          label="Data"
          value={values.data}
          onChange={() => {}}
          disabled
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <OptionSelectV2
          label="Tipo de Serviços"
          codigo="TIPO_SERVICO"
          value={values.tipoServico}
          onSelect={() => {}}
          disabled
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <InputV2
          label="Cidade"
          name="cidade"
          value={values.cidade || ''}
          onChange={() => {}}
          disabled
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <UsuarioSelectV2
          label="Inspetor"
          grupos={[Role.ADMIN, Role.INSPETOR]}
          value={values.inspetor}
          onSelect={() => {}}
          disabled
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <UsuarioSelectV2
          label="Parceiro"
          grupos={[Role.ADMIN, Role.INSPETOR]}
          value={values.inspetorAuxiliar}
          onSelect={() => {}}
          disabled
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <WidgetV2
          title="Horários"
          collapse={false}
          initialExpanded
          insideTab
          sxContent={{ p: 1.5 }}
          actions={[{
            title: 'Mapa',
            show: pontos.length > 0,
            onClick: () => setOpenMapa(true),
          }]}
        >
          <Grid container spacing={1}>
            {JORNADA_ITEM_TIPOS.map(({ tipo, timeField, label }) => {
              const fotoUrl = byTipo[tipo]?.foto?.url;
              return (
                <Grid key={tipo} size={{ xs: 12, sm: 6 }}>
                  <Box sx={{ position: 'relative', pr: '46px' }}>
                    <InputFormatV2
                      label={label}
                      value={values[timeField]}
                      onChange={() => {}}
                      format="##:##"
                      placeholder="HH:MM"
                      disabled
                    />
                    {fotoUrl ? (
                      <Tooltip title="Ver foto">
                        <IconButton
                          size="small"
                          aria-label={`Ver foto de ${label}`}
                          onClick={() => openFoto(tipo)}
                          sx={{
                            position: 'absolute',
                            right: 0,
                            bottom: 0,
                            width: 40,
                            height: 40,
                            border: 1,
                            borderColor: 'primary.main',
                            borderRadius: 1,
                            color: 'primary.main',
                          }}
                        >
                          <PhotoCameraOutlinedIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                  </Box>
                  <JornadaGeoLine item={byTipo[tipo]} />
                </Grid>
              );
            })}
            <Grid size={{ xs: 12, sm: 6 }} sx={{ pb: 1.5 }}>
              <Box sx={{ pr: '46px' }}>
                <InputV2 label="Hora Total Trabalhada" disabled value={values.jornadaTotal || ''} />
              </Box>
            </Grid>
          </Grid>
        </WidgetV2>
      </Grid>
    </Grid>
  );

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={onCloseLocal}
      handlerConfirm={onCloseLocal}
      title="Jornada Medição"
      maxWidth="lg"
      fullWidth
      readOnly
    >
      <TabFormV2
        currentTab={tab}
        onChangeTab={setTab}
        tabPanels={[
          { label: 'Informações gerais', element: informacoesGerais },
          {
            label: 'Inspeções',
            element: (
              <InspecoesDia
                usuarioId={values.inspetor}
                dia={values.data}
                tipoServicoId={values.tipoServico}
                inicioJornada={values.inicioJornada}
              />
            ),
          },
        ]}
      />
      <JornadaPontosMap
        open={openMapa}
        onClose={() => setOpenMapa(false)}
        itens={values.itens}
      />
      <ImageViewerV2
        open={viewerOpen}
        onClose={() => setViewerOpen(false)}
        images={fotosJornada}
        activeIndex={viewerIndex}
      />
    </DialogDefaultV2>
  );
};

Formulario.propTypes = {
  open: PropTypes.bool.isRequired,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  loadJornada: PropTypes.func.isRequired,
  jornada: PropTypes.object,
};

const mapStateToProps = (state) => ({
  jornada: selectorsJornada.getSelectedJornada(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsJornada,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Formulario));
